import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propRequired, propMinValue, propLengthMax, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { CustomerNoteActionTypeDto, CustomerNoteActionTypeEditDto, newCustomerNoteActionType } from "./types";
import { useCustomerNoteActionTypes } from "../../common/enum";
import { UseListStore } from "../../common/listStore";

export const CustomerNoteActionTypeDialog = (props: {
    close: () => void;
    customerNoteActionTypes: CustomerNoteActionTypeEditDto | null;
    onChange(): void;
    useListStore: UseListStore<CustomerNoteActionTypeDto>;
}) => {
    const [useStore] = useState(() => createEntityStore<CustomerNoteActionTypeEditDto>({
        data: props.customerNoteActionTypes === null ? newCustomerNoteActionType() : { ...props.customerNoteActionTypes },
        path: "settings/customerNoteActionTypes",
        fetchOnInit: false,
        id: props.customerNoteActionTypes != null ? props.customerNoteActionTypes.id : null,
        getNewId: p => p.id!,
        onSaved() {
            props.onChange();
            props.close();
            useCustomerNoteActionTypes.getState().uninit();
        },
        propValidators: [
            propRequired("name"),
            propLengthMax("name", 50),
            propRequired("code"),
            propValueValidator("code", (p, e) =>
                props.useListStore.getState().items.some(r => r.code === p && (e.id == null || e.id !== r.id)) &&
                "Code must be unique."),
            propLengthMax("code", 3),
            propValidValue("priority", "priorityFormatted"),
            propRequired("priority"),
            propMinValue("priority", 0)
        ]
    }));

    const { save, id, isSaveDisabled } = useStore(p => ({ save: p.save, id: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{id == null ? `New note action type` : `Edit note action type - ${props.customerNoteActionTypes?.name}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useStore)("name", "Name")}</Grid>
                <Grid item xs={12}>{propTextField(useStore)("code", "Code")}</Grid>
                <Grid item xs={12}>{propBoolField(useStore)("active", "Active")}</Grid>
                <Grid item xs={12}>{propNumberField(useStore)("priority", "priorityFormatted", "Priority")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};